__turbopack_context__.v({
  "blok-big-title": "sb-media-module__wNL3dq__blok-big-title",
  "blok-subtitle": "sb-media-module__wNL3dq__blok-subtitle",
  "blok-title": "sb-media-module__wNL3dq__blok-title",
  "desktop": "sb-media-module__wNL3dq__desktop",
  "mobile": "sb-media-module__wNL3dq__mobile",
  "wrapper": "sb-media-module__wNL3dq__wrapper",
});
